import {
	GET_ALL_EVENTS,
	SAVE_EVENT,
	DELETE_EVENT
} from '../../Actions/Admin/ManageEventActions';

const initialState = {
	events: []
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ALL_EVENTS:
			return {
				...state,
				loading: true,
				events: action.payload
			};
		
		case SAVE_EVENT:
			return {
				...state,
				events: action.payload
			};
		case DELETE_EVENT:
			return {
				...state,
				events: action.payload
			};
		default:
			return state;
	}
};
